<loren-page-content>
  <div class="row">
    <div class="col-md-4 h-100">
      @if(notification) {
      <loren-card
        [iconName]="'warning'"
        [title]="notification.title"
        [subTitle]="notification.notificationTime | lorenDate">
        <div>{{ notification.content }}</div>
      </loren-card>
      }
    </div>
    @if(notification.location) {
    <div class="col-md-8 h-100">
      <loren-card>
        <loren-base-map
          [location]="{
            lat: notification.location.latitude,
            lng: notification.location.longitude
          }"
          [scrollWheelZoom]="true"
          [markerImage]="'/assets/icons/warning-red.png'"
          [popupMessage]="
            notification.content +
            ' ' +
            (notification.notificationTime | lorenDate)
          "
          [mapHeight]="500">
        </loren-base-map>
      </loren-card>
    </div>
    }
  </div>
</loren-page-content>
